module.exports = __WEBPACK_EXTERNAL_MODULE__31347__;